import {CanActivateFn, Router} from '@angular/router'
import {inject} from '@angular/core'
import {map} from 'rxjs'
import {AuthService} from '@riverfortress/ng-firebase-devkit'

export const onlyAuthenticatedGuard: CanActivateFn = (state) => {
  const auth = inject(AuthService)
  const router = inject(Router)

  return auth.isAuthenticated$.pipe(
    map(isAuthenticated => {
      if (isAuthenticated) return true

      router.navigate(['/auth', 'sign-in'], {queryParams: {redirect: state.url}})
      return false
    }),
  )
}

export const onlyNotAuthenticatedGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService)
  const router = inject(Router)

  return auth.isAuthenticated$.pipe(
    map(isAuthenticated => {
      if (!isAuthenticated) return true

      router.navigate(['/dashboard'])
      return false
    }),
  )
}
